export default __webpack_public_path__ + "static/media/crypto-pay-icon.c55503a2.svg";